import { JackpotSitAndGoGame, FreeEntryType, JackpotSitAndGoPayout } from './models'
import { CurrencyCode } from '../../constants'

export const defaultPayoutStructure: JackpotSitAndGoPayout[] = [
	{ probability: 3, multiplier: 200, distribution: [0.75, 0.15, 0.1], blinds: 5 },
	{ probability: 15, multiplier: 50, distribution: [1], blinds: 5 },
	{ probability: 50, multiplier: 20, distribution: [1], blinds: 5 },
	{ probability: 150, multiplier: 10, distribution: [1], blinds: 5 },
	{ probability: 500, multiplier: 5, distribution: [1], blinds: 5 },
	{ probability: 3282, multiplier: 3, distribution: [1], blinds: 5 },
	{ probability: 6000, multiplier: 2, distribution: [1], blinds: 5 },
]

export const sc5PayoutStructure: JackpotSitAndGoPayout[] = [
	{ probability: 1, multiplier: 12000, distribution: [50 / 60, 5 / 60, 5 / 60], blinds: 5 },
	{ probability: 150, multiplier: 50, distribution: [1], blinds: 5 },
	{ probability: 500, multiplier: 20, distribution: [1], blinds: 5 },
	{ probability: 1250, multiplier: 10, distribution: [1], blinds: 5 },
	{ probability: 6000, multiplier: 4, distribution: [1], blinds: 5 },
	{ probability: 31769, multiplier: 3, distribution: [1], blinds: 5 },
	{ probability: 60330, multiplier: 2, distribution: [1], blinds: 5 },
]

export const isSc5Game = (game: JackpotSitAndGoGame): boolean =>
	game.buyIn.currencyCode === CurrencyCode.SWEEPS && game.buyIn.amount === 5

export const withSc5PayoutStructure = (game: JackpotSitAndGoGame): JackpotSitAndGoGame =>
	isSc5Game(game) ? { ...game, payoutStructure: sc5PayoutStructure } : game

export class JackpotSitAndGoGameBuilder {
	constructor(
		private buyInAmount: number,
		private currencyCode: CurrencyCode,
		private freeEntryType: FreeEntryType
	) {}
	private numberOfPlayers: number = 3
	private startingChips: number = 500
	private timeBank: number = 30

	public withNumberOfPlayers(players: number): this {
		this.numberOfPlayers = players;
		return this;
	}

	public withStartingChips(chips: number): this {
		this.startingChips = chips;
		return this;
	}

	public withTimeBank(time: number): this {
		this.timeBank = time;
		return this;
	}

	build(): JackpotSitAndGoGame {
		return {
			buyIn: {
				amount: this.buyInAmount,
				currencyCode: this.currencyCode
			},
			numberOfPlayers: this.numberOfPlayers,
			startingChips: this.startingChips,
			timeBank: this.timeBank,
			freeEntryType: this.freeEntryType,
			payoutStructure: defaultPayoutStructure
		}
	}
}

export const createJackpotSitAndGoGame = (
	buyInAmount: number,
	currencyCode: CurrencyCode,
	freeEntryType: FreeEntryType = FreeEntryType.Uncommon,
): JackpotSitAndGoGameBuilder => {
	return new JackpotSitAndGoGameBuilder(buyInAmount, currencyCode, freeEntryType)
}
